/** Release editor screenshot in the hero frame, cropped to its top-left. */
export default function SuperHeroShot() {
  return (
    <figure className="relative z-[1] m-0 aspect-[1.36] w-[min(700px,100%)] rotate-1 overflow-hidden rounded-[25px] bg-white/[0.12] p-[10px] shadow-[0_30px_90px_rgba(0,0,0,0.46)] backdrop-blur-[12px] max-[680px]:rotate-0">
      <img
        src="/marketing/super-singles/super-single-release-editor.webp"
        alt="Lutely Super Single release editor showing included clean and instrumental versions"
        className="w-[146%] max-w-none rounded-[18px] bg-white"
      />
    </figure>
  );
}
